<template>
  <div id="data-list-list-view" class="data-list-container ">

    <create-update-tax-data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table
      :sst="true"
      stripe
      @search="handleSearch"
      @sort="handleSort"
      max-items="20"
      search
      noDataText="No se encontraron datos"
      :data="taxData">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 float-left text-base text-primary">Añadir datos fiscales</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">
          Razón Social
        </vs-th>
        <vs-th sort-key="rfc">
          RFC
        </vs-th>
        <vs-th sort-key="cp">
          Domicilio Fiscal
        </vs-th>
        <vs-th sort-key="regimen">
          Régimen Fiscal
        </vs-th>
        <vs-th sort-key="role">
          Uso CFDI
        </vs-th>
        <vs-th sort-key="created_at">
          Default
        </vs-th>
        <vs-th>
          Acciones
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

          <vs-td :data="data[indextr]['company']">
            {{data[indextr]['company']}}
          </vs-td>

          <vs-td :data="data[indextr]['rfc']">
            {{data[indextr]['rfc']}}
          </vs-td>

          <vs-td :data="data[indextr]['location_code']">
            {{data[indextr]['location_code']}}
          </vs-td>

          <vs-td :data="data[indextr]['regimen_fiscal']">
            {{data[indextr]['regimen_fiscal']}}
          </vs-td>

          <vs-td :data="data[indextr]['use_cfdi']">
            {{data[indextr]['use_cfdi']}}
          </vs-td>

          <vs-td :data="data[indextr]['default']">
            <vs-chip v-if="data[indextr]['default']" color="success">Habilitado</vs-chip>
            <vs-chip v-if="!data[indextr]['default']">Deshabilitado</vs-chip>
          </vs-td>

          <vs-td>
            <vx-tooltip  text="Editar datos fiscales" position="top" class="d-inline-block mr-3">
              <feather-icon icon="EditIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current" @click="updateData(data[indextr])" />
            </vx-tooltip>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
    <br>
    <vs-pagination :total="getTotalPages" v-model="currentPage" @input="handleChangePage"></vs-pagination>
  </div>
</template>

<script>

import CreateUpdateTaxDataSidebar from './CreateUpdateTaxDataSidebar.vue'
import moment from "moment";

export default {
  components: {
    CreateUpdateTaxDataSidebar
  },
  data(){
    return {
      currentPage: 1,
      searching: '',
      sort: {
        key: null,
        active: null
      },
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    taxData() {
      return this.$store.state.taxData.taxData.data;
    },
    getTotalPages() {
      return this.$store.state.taxData.taxData.pagination.total
    },
    getDate() {
      return moment().format("Y-m-dTH:i:sP.");
    },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    }
  },
  methods: {
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    updateData(invoice) {
      this.sidebarData = {
        id: invoice.id,
        company: invoice.company,
        rfc: invoice.rfc,
        cfdi_use: invoice.use_cfdi,
        location_code: invoice.location_code,
        regimen_fiscal: invoice.regimen_fiscal,
        selected: invoice.default
      };
      this.toggleDataSidebar(true);
    },
    handleSearch(searching) {
      this.searching = searching;
      if (this.sort.active === 'desc') {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
      } else if (this.sort.active === 'asc') {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: searching, sort: this.sort.key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: searching}).catch(err => { console.error(err) })
      }
    },
    handleChangePage(page) {
      this.currentPage = page;
      if (this.sort.active === 'desc') {
        this.$store.dispatch('taxData/getAll', {page: page - 1, search: this.searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
      } else if (this.sort.active === 'asc') {
        this.$store.dispatch('taxData/getAll', {page: page - 1, search: this.searching, sort: this.sort.key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('taxData/getAll', {page: page - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    },
    handleSort(key, active) {
      this.sort = {key, active};
      if (active === 'desc') {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: this.searching, sort: "-" + key}).catch(err => { console.error(err) })
      } else if (active === 'asc') {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: this.searching, sort: key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    }
  },
  created() {
    this.$store.dispatch('taxData/getAll', {page: this.currentPage - 1}).catch(err => { console.error(err) })
  }
}
</script>

<style lang="scss">
#data-list-list-view {

  .name-w{
    width: 25%;
  }
  .mail-w{
    width: 25%;
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
